/**
 * Randall's Refined Scripts — Animations Module
 * ==============================================
 * Intro animation, scroll animations, and transition utilities.
 */

var RRS = window.RRS || {};

RRS.Animations = (function() {
  'use strict';

  var INTRO_STORAGE_KEY = 'rrs_intro_skipped';
  var INTRO_SESSION_KEY = 'rrs_intro_shown';

  /**
   * Initialize Intro Animation
   * Handles the homepage intro overlay with SVG draw animation
   */
  function initIntroAnimation() {
    var overlay = document.getElementById('intro-overlay');
    if (!overlay) return;

    // Check if user has permanently skipped or already seen this session
    var permanentlySkipped = localStorage.getItem(INTRO_STORAGE_KEY) === 'true';
    var shownThisSession = sessionStorage.getItem(INTRO_SESSION_KEY) === 'true';

    // Check for reduced motion preference
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (permanentlySkipped || shownThisSession) {
      overlay.setAttribute('hidden', '');
      overlay.remove();
      return;
    }

    // Mark as shown for this session
    sessionStorage.setItem(INTRO_SESSION_KEY, 'true');

    // If reduced motion, show briefly then hide
    if (prefersReducedMotion) {
      setTimeout(function() {
        hideIntroOverlay(false);
      }, 500);
      return;
    }

    // Auto-hide after animation completes (2.5s draw + 0.5s pause)
    var autoHideTimer = setTimeout(function() {
      hideIntroOverlay(false);
    }, 3000);

    // Skip button
    var skipBtn = overlay.querySelector('[data-intro-skip]');
    if (skipBtn) {
      skipBtn.addEventListener('click', function() {
        clearTimeout(autoHideTimer);
        // Persist skip preference
        localStorage.setItem(INTRO_STORAGE_KEY, 'true');
        hideIntroOverlay(true);
      });
    }

    function hideIntroOverlay(skipped) {
      overlay.classList.add('intro-overlay--exiting');
      overlay.addEventListener('animationend', function() {
        overlay.setAttribute('hidden', '');
        overlay.remove();
      }, { once: true });
    }
  }

  /**
   * Scroll Reveal Animation
   * Reveals elements as they enter the viewport
   * Usage: Add data-reveal attribute to elements
   */
  function initScrollReveal() {
    var revealElements = document.querySelectorAll('[data-reveal]');
    if (revealElements.length === 0) return;

    // Check reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Show all immediately
      revealElements.forEach(function(el) {
        el.classList.add('revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /**
   * Stagger Animation Utility
   * Adds staggered delay to child elements
   * @param {string} selector - Parent container selector
   * @param {string} childSelector - Child elements selector
   * @param {number} baseDelay - Base delay in ms (default 100)
   */
  function staggerChildren(selector, childSelector, baseDelay) {
    baseDelay = baseDelay || 100;
    var container = document.querySelector(selector);
    if (!container) return;

    var children = container.querySelectorAll(childSelector);
    children.forEach(function(child, index) {
      child.style.transitionDelay = (index * baseDelay) + 'ms';
    });
  }

  /**
   * Public API
   */
  return {
    init: function() {
      initScrollReveal();
      // Note: initIntroAnimation is called inline in the section
      // to ensure it runs before DOMContentLoaded
    },
    initIntroAnimation: initIntroAnimation,
    staggerChildren: staggerChildren
  };
})();
